import { useAuth } from '@/features/auth/authContext'

/**
 * A missing switches map (older or platform sessions) or a missing key inside
 * it means allowed — only an explicit `false` turns a capability off. Keep
 * this pure so it can be tested without an auth provider.
 */
export function isSwitchAllowed(
  switches: Record<string, boolean> | undefined,
  capability: string,
): boolean {
  if (!switches) return true
  const value = switches[capability]
  return value ?? true
}

/**
 * Hides refund, payment-plan and invite-staff/-manager UI app-wide per the
 * active Standort's `session.switches` (spec §5.2). This only hides a button;
 * the server still decides, and a `403 CAPABILITY_REQUIRED` is still handled
 * wherever the action is attempted.
 *
 * `hooks/` importing `useAuth` is the established auth exception (CLAUDE.md §4).
 */
export function useSwitch(capability: string): boolean {
  const { session } = useAuth()
  return isSwitchAllowed(session?.switches, capability)
}
